import React, { useLayoutEffect, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { useFocus } from '../../contexts/FocusContext';
import { getFullscreenPortalTarget } from './fullscreenPortal';
import './HudVisibility.css';

/** Hide presentation only. Media, subscriptions and chat stay mounted. */
export default function HudVisibility({ hidden, onShow, showRestore = true }: { hidden: boolean; onShow: () => void; showRestore?: boolean }) {
  const { setOverlaysSuspended } = useFocus();
  const [, updateFullscreen] = useState(0);
  useEffect(() => {
    const update = () => updateFullscreen(value => value + 1);
    document.addEventListener('fullscreenchange', update);
    document.addEventListener('webkitfullscreenchange', update);
    return () => { document.removeEventListener('fullscreenchange', update); document.removeEventListener('webkitfullscreenchange', update); };
  }, []);
  useLayoutEffect(() => {
    if (!hidden) return;
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
    document.body.classList.add('vv-hud-hidden');
    setOverlaysSuspended(true);
    return () => {
      document.body.classList.remove('vv-hud-hidden');
      setOverlaysSuspended(false);
    };
  }, [hidden, setOverlaysSuspended]);
  if (!hidden || !showRestore) return null;
  return createPortal(<button type="button" data-hud-restore="true" aria-label="Show UI" title="Show UI"
    onClick={event => { event.stopPropagation(); onShow(); }} onPointerDown={event => event.stopPropagation()}
    className="vv-hud-restore"><FaArrowLeft size={26} aria-hidden="true" /><span>Show UI</span></button>, getFullscreenPortalTarget());
}
